import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home.jsx";
import Blogs from "./pages/Blogs.jsx";
import Contact from "./pages/Contact.jsx";
import { About } from './pages/About.jsx';
import { Quotes } from './pages/Quotes.jsx';
import { PoemsEnglish } from './pages/PoemsEnglish.jsx';
import { PoemsMarathi } from './pages/PoemsMarathi.jsx';
import { Privacy } from './pages/privacy.jsx';
import { TheEvolutionofRomanticPoetry } from './components/blogpage/TheEvolutionofRomanticPoetry.jsx';
import { PoetryasTherapy } from './components/blogpage/PoetryasTherapy.jsx';
import { TopTenTimelessPoems } from './components/blogpage/TopTenTimelessPoems.jsx';
import { ThePowerofWords } from './components/blogpage/ThePowerofWords.jsx';
import { FamousPoetsAndStories } from './components/blogpage/FamousPoetsAndStories.jsx';
import { InspirationalQuotesforEveryStage } from './components/blogpage/InspirationalQuotesforEveryStage.jsx';
import { FromThoughttoVerse } from './components/blogpage/FromThoughttoVerse.jsx';
import { CraftQuotesThatSpeakVolumes } from './components/blogpage/CraftQuotesThatSpeakVolumes.jsx';
import { CreativeWaystoDisplayQuotes } from './components/blogpage/CreativeWaystoDisplayQuotes.jsx';
import ReactGA from 'react-ga4';
import CookieConsent from 'react-cookie-consent';

// Initialize Google Analytics with your GA4 Measurement ID
ReactGA.initialize('G-EHWFYTYBZT'); 

// Component to handle Google Analytics page view tracking
const AnalyticsHandler = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return null; // This component doesn't render anything
};

function App() {
  return (
    <>
     <CookieConsent
        location="bottom"
        buttonText="I understand"
        style={{ background: "#2B373B" }}
        buttonStyle={{ background: "#ff0000", color: "white", fontSize: "12px" }}
        expires={150}
      >
        This website uses cookies to enhance the user experience.
      </CookieConsent>
    <BrowserRouter>
      <AnalyticsHandler /> {/* Ensures tracking logic is within <BrowserRouter> */}
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="quotes" element={<Quotes />} />
          <Route path="poems-eng" element={<PoemsEnglish />} />
          <Route path="poems-mar" element={<PoemsMarathi />} />
          <Route path="privacy-policy" element={<Privacy />} />
          <Route path="blogs/the-evolution-of-romantic-poetry" element={<TheEvolutionofRomanticPoetry />} />
          <Route path="blogs/poetry-as-therapy" element={<PoetryasTherapy />} />
          <Route path="blogs/top-10-timeless-poems" element={<TopTenTimelessPoems />} />
          <Route path="blogs/the-power-of-words" element={<ThePowerofWords />} />
          <Route path="blogs/famous-poets-and-the-stories-behind-their-masterpiece" element={<FamousPoetsAndStories />} />
          <Route path="blogs/inspirational-quotes-for-every-stage" element={<InspirationalQuotesforEveryStage />} />
          <Route path="blogs/from-thoughts-to-verse" element={<FromThoughttoVerse />} />
          <Route path="blogs/craft-quotes-that-speak-volumes" element={<CraftQuotesThatSpeakVolumes />} />
          <Route path="blogs/creative-ways-to-display-quotes" element={<CreativeWaystoDisplayQuotes />} />
        </Route>
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
